import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
//import About from "@/views/About.vue";
import Subprogram from "@/views/Subprogram.vue";
import Glosario from "@/views/Glosario.vue";
import RegistrosAcelerometricos from "@/views/RegistrosAcelerometricos.vue";
// import ReportesAcelerometricos from "@/views/ReportesAcelerometricos.vue";
import EdificacionesInstrumentadas from "@/views/EdificacionesInstrumentadas.vue";
import EdificioInstrumentadoView from "@/views/EdificioInstrumentadoView.vue";
import Register from "@/views/Register.vue";
import Login from "@/views/Login.vue";
import Recover from "@/views/Recover.vue";
import NewPassword from "@/views/NewPassword.vue";
//import Projects from "@/views/Projects.vue";
// import ViewWithTable from "@/views/ViewWithTable.vue";
// import WebService from "@/views/WebService.vue";
// import Aplicaciones from "@/views/Aplicaciones.vue";
//import Laboratory from "@/views/Laboratory.vue";
import NotFound from "@/views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/registro",
    name: "Register",
    component: Register,
  },
  {
    path: "/inicio-sesion",
    name: "Login",
    component: Login,
  },
  {
    path: "/recuperar-cuenta",
    name: "Recuperar Cuenta",
    component: Recover,
  },
  {
    path: "/recuperar-contrasena/:token",
    name: "Nueva contraseña",
    component: NewPassword,
  },
  {
    path: `/sismos-historicos`,
    name: "Sismos Históricos",
    component: Subprogram,
  },
  {
    path: "/informacion-acelerometrica",
    name: "Información",
    component: Subprogram,
  },
  {
    path: "/norma-e.030",
    name: "Norma E.030",
    component: Subprogram,
  },

  {
    path: "/red-acelerometrica",
    name: "Red Acelerométrica",
    component: Subprogram,
  },
  {
    path: "/edificaciones-instrumentadas",
    name: "Edificaciones Instrumentadas",
    component: EdificacionesInstrumentadas,
    meta: { requiereAutenticacion: true },
  },
  {
    path: "/edificaciones-instrumentadas/:code/:type",
    name: "Edificaciones instrumentada",
    component: EdificioInstrumentadoView,
    meta: { requiereAutenticacion: true },
    props: true,
  },
  {
    name: "Especificaciones Técnicas",
    path: "/especificaciones-tecnicas",
    component: Subprogram,
  },
  /*  {
     path: "/norma-e.030",
     name: "Norma E.030",
     component: Subprogram,
     children: [
       {
         name: "Importancia",
         path: "importancia",
         component: Subprogram
       },
       {
         name: "Especificaciones",
         path: "especificaciones-tecnicas",
         component: Subprogram
       },
       {
         name: "Información Acelerométrica",
         path: "informacion-acelerometrica-norma-e0.30",
         component: Subprogram
       },
       {
         name: "Edificios Instrumentados",
         path: "edificios-instrumentados",
         component: Subprogram
       },
       {
         name: "Reportes Norma",
         path: "reportes-norma",
         component: Subprogram
       }
     ]
   }, */
  {
    path: "/reportes-registros-acelerometricos",
    name: "Registros Acelerométricos",
    component: RegistrosAcelerometricos,
  },
  // {
  //   path: "/reportes-acelerometricos",
  //   name: "Reportes Acelerométricos",
  //   component: ReportesAcelerometricos
  // },
  {
    path: "/glosario",
    name: "Glosario",
    component: Glosario,
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiereAutenticacion)) {
    if (!token) {
      next({
        path: "/inicio-sesion",
        query: { redireccion: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
